import { Theme, Tooltip, Typography } from "@material-ui/core";
import _ from "lodash";
import React, { Component, PureComponent } from "react";
import { WithStyles, createStyles, withStyles } from "@material-ui/core";

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}
const styles = (theme: Theme) =>
  createStyles({
    htmlPopper: arrowGenerator("#dadde9"),
    htmlTooltip: {
      backgroundColor: "#fff",
      borderRadius: 4,
      color: "rgba(0, 0, 0, 0.87)",
      minWidth: 267,
      width: '100%',
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
      "& b": {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    arrowPopper: arrowGenerator(theme.palette.grey[700]),
    arrow: {
      position: "absolute",
      fontSize: 6,
      width: "3em",
      height: "3em",
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid",
      },
    },
    dropdownList:{
      padding: 0,
      '& li':{
        padding: '7px',
        listStyle: 'none',
        fontSize: 14,
      },
    },
    plusNumber:{
      color: '#1d7dea',
      cursor: 'pointer',
    },
  });

interface Props extends WithStyles<typeof styles> {
  data: string[];
  truncateLength: number;
  displayCount: number;
}

interface State {
  arrowRef: null;
}

class MyPATTruncateText extends PureComponent<Props, State> {
  // props: Props,
  // state: state
  // data: string[],
  // { truncateLength, displayCount }: any
  //) => {
  constructor(props: any) {
    super(props);
    this.state = {
      arrowRef: null,
    };
  }
  handleArrowRef = (node: any) => {
    this.setState({
      arrowRef: node,
    });
  };
  render() {
    const { data, truncateLength, displayCount, classes } = this.props;

    //  const owners = _.get(this.props.contentRequest, 'requestInfo.owners','');
    // If Required to show only unique names
    let isNameTruncated = false;

    const requestOwnerNames: any = new Set();
    // const requestOwnerNames:any=[];
    for (let owner of data) {
      requestOwnerNames.add(owner);
      // requestOwnerNames.push(owner.client.name);
    }
    const ownerNamesInArray: any = [...requestOwnerNames];
    let isNamesMoreThan2 =
      ownerNamesInArray.length > displayCount ? true : false;
    let untruncatedNames = ownerNamesInArray.slice(0, displayCount);
    let namesToReturn = untruncatedNames
      .map((name: string) => {
        let trucatedValue = _.truncate(name, { length: truncateLength });
        if (name.length != trucatedValue.length) {
          isNameTruncated = true;
        }
        return trucatedValue;
      })
      .join(", ");
    namesToReturn = namesToReturn.length > 0 ? namesToReturn : "N/A";
    let tooltiptitle = "";
    let tooltipDetail = "";
    if (isNamesMoreThan2) {
      let extraLength = ownerNamesInArray.length - displayCount;
      tooltipDetail = ownerNamesInArray.map((name: string) => <li>{name}</li>);
      tooltiptitle = ` +${extraLength}`;
    }
    untruncatedNames = untruncatedNames.map((name: string) => <li>{name}</li>);

    return (
      <span>
        {isNameTruncated ? (
          <Tooltip
            placement="bottom-end"
            style={{ cursor: "pointer" }}
            classes={{
              popper: classes.htmlPopper,
              tooltip: classes.htmlTooltip,
            }}
            PopperProps={{
              popperOptions: {
                modifiers: {
                  arrow: {
                    enabled: Boolean(this.state.arrowRef),
                    element: this.state.arrowRef,
                  },
                },
              },
            }}
            title={
              <>
                <ul className={classes.dropdownList}>{untruncatedNames}</ul>
                <span className={classes.arrow} ref={this.handleArrowRef} />
              </>
            }
          >
            <span className={classes.plusNumber}>{namesToReturn}</span>
          </Tooltip>
        ) : (
          namesToReturn
        )}
        {isNamesMoreThan2 && (
          <Tooltip
            placement="bottom-end"
            classes={{
              popper: classes.htmlPopper,
              tooltip: classes.htmlTooltip,
            }}
            PopperProps={{
              popperOptions: {
                modifiers: {
                  arrow: {
                    enabled: Boolean(this.state.arrowRef),
                    element: this.state.arrowRef,
                  },
                },
              },
            }}
            title={
              <>
                <ul className={classes.dropdownList}>
                  {tooltipDetail}
                  <span className={classes.arrow} ref={this.handleArrowRef} />
                </ul>
              </>
            }
          >
            <span className={classes.plusNumber}>{tooltiptitle}</span>
          </Tooltip>
        )}
      </span>
    );
  }
}

export default withStyles(styles)(MyPATTruncateText);
